import auth from './reducers';

export { default as authActions } from './actions';
export { default as authTypes }   from './types';

export default auth;
